import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { BuildingReferenceObj } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"
import { ContactDetailsObj } from "scrivito/Objs/ContactDetails/ContactDetailsObjClass"

export function useBuildingReferenceGeneralInfoCopiedText(
  buildingReferenceObj: BuildingReferenceObj
) {
  const { t } = useTranslation()

  const contactDetailsObj = buildingReferenceObj
    ?.get("locationContactDetails")?.[0]
    ?.get("contactDetails") as ContactDetailsObj
  const clientContactDetailsObj = buildingReferenceObj
    ?.get("clientContactDetails")?.[0]
    ?.get("contactDetails") as ContactDetailsObj
  const architectContactDetailsObj = buildingReferenceObj
    ?.get("architectContactDetails")?.[0]
    ?.get("contactDetails") as ContactDetailsObj
  const plannerContactDetailsObj = buildingReferenceObj
    ?.get("plannerContactDetails")?.[0]
    ?.get("contactDetails") as ContactDetailsObj

  const contactDetails = {
    name: contactDetailsObj?.get("name") || "",
    street: contactDetailsObj?.get("street") || "",
    city: contactDetailsObj?.get("city") || "",
    country: contactDetailsObj?.get("country") || ""
  }

  const hasContactDetails =
    contactDetails.name ||
    contactDetails.street ||
    contactDetails.city ||
    contactDetails.country

  const clientContactDetails = {
    name: clientContactDetailsObj?.get("name") || "",
    street: clientContactDetailsObj?.get("street") || "",
    city: clientContactDetailsObj?.get("city") || "",
    country: clientContactDetailsObj?.get("country") || "",
    website: clientContactDetailsObj?.get("website") || ""
  }

  const hasClientContactDetails =
    clientContactDetails.name ||
    clientContactDetails.street ||
    clientContactDetails.city ||
    clientContactDetails.country ||
    clientContactDetails.website

  const architectContactDetails = {
    name: architectContactDetailsObj?.get("name") || "",
    street: architectContactDetailsObj?.get("street") || "",
    city: architectContactDetailsObj?.get("city") || "",
    country: architectContactDetailsObj?.get("country") || "",
    website: architectContactDetailsObj?.get("website") || ""
  }

  const hasArchitectContactDetails =
    architectContactDetails.name ||
    architectContactDetails.street ||
    architectContactDetails.city ||
    architectContactDetails.country ||
    architectContactDetails.website

  const plannerContactDetails = {
    name: plannerContactDetailsObj?.get("name") || "",
    street: plannerContactDetailsObj?.get("street") || "",
    city: plannerContactDetailsObj?.get("city") || "",
    country: plannerContactDetailsObj?.get("country") || "",
    website: plannerContactDetailsObj?.get("website") || ""
  }

  const hasPlannerContactDetails =
    plannerContactDetails.name ||
    plannerContactDetails.street ||
    plannerContactDetails.city ||
    plannerContactDetails.country ||
    plannerContactDetails.website

  const buildingReferenceDescription = buildingReferenceObj.get("description")

  const generalInfoText = useMemo(
    () => `${t("BuildingReference.GeneralInformation")}

${
  hasContactDetails
    ? `${t("BuildingReference.Location")}
${contactDetails.name ? `${contactDetails.name}| ` : ""}${
        contactDetails.street ? `${contactDetails.street}| ` : ""
      }${contactDetails.city ? `${contactDetails.city}| ` : ""}${
        contactDetails.country ? `${contactDetails.country}` : ""
      }`
    : ""
}

${t("BuildingReference.BuildingInformation")}
${buildingReferenceDescription}

${
  hasClientContactDetails
    ? `${t("BuildingReference.Client")}\n${clientContactDetails.name}\n${
        clientContactDetails.street
      }\n${clientContactDetails.city}\n${clientContactDetails.country}\n${
        clientContactDetails.website
      }\n`
    : ""
}
${
  hasArchitectContactDetails
    ? `${t("BuildingReference.Architect")}\n${architectContactDetails.name}\n${
        architectContactDetails.street
      }\n${architectContactDetails.city}\n${architectContactDetails.country}\n${
        architectContactDetails.website
      }\n`
    : ""
}
${
  hasPlannerContactDetails
    ? `${t("BuildingReference.Planner")}\n${plannerContactDetails.name}\n${
        plannerContactDetails.street
      }\n${plannerContactDetails.city}\n${plannerContactDetails.country}\n${
        plannerContactDetails.website
      }\n`
    : ""
}
`,
    [
      t,
      buildingReferenceObj,
      contactDetails,
      architectContactDetails,
      clientContactDetails,
      plannerContactDetails
    ]
  )

  return generalInfoText
}
